import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {  LocalizationService } from '@abp/ng.core';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  lang=this.localizationService.currentLang;
  @Input() openMenu: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  constructor(private router: Router,
    private localizationService:LocalizationService
  ) {}
  ngOnInit(): void {
    this.updateMenuSelection(this.router.url);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateMenuSelection(event.url);
      }
    });
  }
  // TODO replace /coming-soon with the actual link
  menu = [
    {
      // name: this.lang=='ar'?'القائمة الرئيسية':'Menu',
      list: [
//         {

//           path: '/yproducts',
//           name: ' Y Dev Project',
//           icon: 'fa-solid fa-apple-whole',
//           selected: false,
//           comingSoon: false,
//           isYdev:true
//         },
        // {
        //   path: null,///coming-soon
        //   name: this.lang=='ar'?'لوحة المعلومات':'Dashboard',
        //   icon: 'fa-light fa-house-chimney',
        //   selected: false,
        //   comingSoon: true,
        // },
        {
          path: '/holiday-homes',
          name: this.lang == 'ar' ? 'بيوت العطلات' : 'Vacation-Homes',
          icon: 'fa-solid fa-hotel',
          selected: false,
        },
        {
          path: '/experiments',
          name: this.lang == 'ar' ? 'التجارب' : 'Experiences',
          icon: 'fa-solid fa-clipboard-list',
          selected: false,
        },
        {
          path: '/financial-transactions',
          name: this.lang == 'ar' ? 'المعاملات المالية' : 'Financial Transactions',
          icon: 'fa-solid fa-money-bill-wave',
          selected: false,
          comingSoon: false,
        },
        {
          path: '/reservations',
          name: this.lang == 'ar' ? 'الحجوزات' : 'Reservations',
          icon: 'fa-solid fa-receipt',
          selected: false,
          comingSoon: false,
        },
        {
          path: '/rating',
          name: this.lang == 'ar' ? 'التقييمات' : 'Ratings',
          icon: 'fa-solid fa-star',
          selected: false,
          comingSoon: false,
        },
        {
          path: '/calendar',
          name: this.lang=='ar'?'التقويم':'Calendar',
          icon: 'fa-regular fa-calendar',
          selected: false,
          comingSoon: false,
        },


//     {
//       name: this.lang=='ar'?'الاعدادات':'Settings',
//       list: [
//         {
//           path: '/coming-soon',
//           name: this.lang=='ar'?'المحادثات مع العملاء':'Conversations',
//           icon: 'fa-light fa-messages',
//           selected: false,
//           comingSoon: true,
//         },
//         {
//           path: '/contact-us',
//           name: this.lang=='ar'?'تواصل مع فريق حياك':'Contact Hyyak',
//           icon: 'fa-light fa-headset',
//           selected: false,
//         },
//         {
//           path: '/settings',
//           name: this.lang=='ar'?'الإعدادات':'Settings',
//           icon: 'fa-light fa-gear',
//           selected: false,
//         },
//         {
//           path: '/coming-soon',
//           name: this.lang=='ar'?'الضوابط والأحكام':'Policy and Control',
//           icon: 'fa-light fa-toolbox',
//           selected: false,
//           comingSoon: true,
//         },
],
},
  ];

  updateMenuSelection(url: string) {
    this.menu.forEach(menu => {
      menu.list.forEach(child => {
        const isSelected = child.path === url;
        if (isSelected) {
          child.selected = isSelected;
        }
      });
    });
  }
}
